import _ from 'underscore'

function rolesFilter(list, role) {
    return _.contains(list, role)
}

export default rolesFilter